import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class SalaryCompensationDetails extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_salary_and_compensation_details');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'bank_account_passbook')}><i class="fas fa-file-download"></i> Bank Account Passbook</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'salary_structure')}><i class="fas fa-file-download"></i> Salary Structure</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_salary_and_compensation_details';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#bank_name').val(data['bank_name']);
    $('#account_number').val(data['account_number']);
    $('#ifsc_code').val(data['ifsc_code']);
    $('#branch_name').val(data['branch_name']);
    $('#incentives').val(data['incentives']);

    $('#old_bank_account_passbook').val(data['bank_account_passbook_new_name']);
    $('#old_salary_structure').val(data['salary_structure_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['pdf','PDF','png','jpg','jpeg','JPEG','JPG','PNG']
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var bank_name    = window.isNullAndUndef($('#bank_name').val());
    var account_number          = window.isNullAndUndef($('#account_number').val());
    var ifsc_code           = window.isNullAndUndef($('#ifsc_code').val());
    var branch_name              = window.isNullAndUndef($('#branch_name').val());
    var incentives         = window.isNullAndUndef($('#incentives').val());

    var bank_account_passbook_temp    = window.isNullAndUndef($('#bank_account_passbook').val());
    var org_bank_account_passbook     = $("#bank_account_passbook").prop("files")[0];
    var bank_account_passbook_name    = $('#bank_account_passbook').val().split('\\').pop();

    var salary_structure_temp        = window.isNullAndUndef($('#salary_structure').val());
    var org_salary_structure         = $("#salary_structure").prop("files")[0];
    var salary_structure_name        = $('#salary_structure').val().split('\\').pop();


    var bank_account_passbook_ext    = '';
    var salary_structure_ext         = '';

    if(bank_account_passbook_temp && salary_structure_temp){
      bank_account_passbook_ext       = bank_account_passbook_temp.split('.').pop();
      salary_structure_ext        = salary_structure_temp.split('.').pop();
    }

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(bank_name && account_number && ifsc_code && branch_name && incentives && file_main_ext.indexOf(bank_account_passbook_ext) >= 0 && file_main_ext.indexOf(salary_structure_ext) >= 0){
      var old_bank_account_passbook                 = $('#old_bank_account_passbook').val();
      var old_salary_structure                  = $('#old_salary_structure').val();
      var all_data                              = {};
      all_data['bank_name']        = window.return_false_null(bank_name);
      all_data['account_number']              = window.return_false_null(account_number);
      all_data['ifsc_code']               = window.return_false_null(ifsc_code);
      all_data['branch_name']                  = window.return_false_null(branch_name);
      all_data['incentives']             = window.return_false_null(incentives);

      all_data['bank_account_passbook']             = window.return_false_null(bank_account_passbook_name);
      all_data['salary_structure']                 = window.return_false_null(salary_structure_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('bank_account_passbook',org_bank_account_passbook);
      body.append('salary_structure',org_salary_structure);
      body.append('old_bank_account_passbook',old_bank_account_passbook);
      body.append('old_salary_structure',old_salary_structure);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_salary_and_compensation_details');
      body.append('function','add_event_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_event_manage_url.php";
      }else{
        url = "/php/admin_event_manage_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('bank_name','account_number','ifsc_code','branch_name','incentives','bank_account_passbook','salary_structure');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">
                            <div className="col-md-12">
                            <label for="name">Bank Account Details (For Salary Credit)</label>
                            </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_bank_account_passbook" placeholder=""/>
                                        <input type="file" className="form-control" id="bank_account_passbook" placeholder="Bank Account Passbook"/>
                                        <label for="name">Bank Account Passbook</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="bank_name" placeholder="Bank Name"/>
                                        <label for="name">Bank Name</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="account_number" placeholder="Account Number"/>
                                        <label for="name">Account Number</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="ifsc_code" placeholder="IFSC Code"/>
                                        <label for="name">IFSC Code</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="branch_name" placeholder="Branch Name"/>
                                        <label for="name">Branch Name</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_salary_structure" placeholder=""/>
                                        <input type="file" className="form-control" id="salary_structure" placeholder="Salary Structure (CTC Breakup)"/>
                                        <label for="name">Salary Structure (CTC Breakup)</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="incentives" placeholder="Variable Pay/Incentives"/>
                                        <label for="name">Variable Pay/Incentives</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF, PNG, JPEG & JPG</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default SalaryCompensationDetails;
